import { SET_EXPAND_TREND_TIMELINE } from '../../../actions/chart';

export default (state = false, action) => {
  switch (action.type) {
    case SET_EXPAND_TREND_TIMELINE:
      return action.payload.value;
    default:
      return state;
  };
};

export const getExpandTrendTimeline = state => state;